import { getUtmAndReferrer, getAffiliateId, buildZohoFormUrl, SourceInformation } from "@utils/campaign-tracker";
import { leadClassification } from "@utils/leadclassifier";
import React, { useEffect, useMemo, useRef, useState } from "react";

interface GlobalFormModalProps {
    onClose: () => void;
    onSuccess: () => void;
    formUrl?: string;
}

const DEFAULT_FORM_URL = "https://forms.zohopublic.in/gallabox/form/Migrationcampaign/formperma/ZImrYqN8ID97q7fmIZ5DLzWIrRQeQaFTGEYezCdIf_M";

const GlobalFormModal: React.FC<GlobalFormModalProps> = ({ onClose, formUrl }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const [campaignDetails] = useState<SourceInformation>(() => getUtmAndReferrer());
    const [affiliateId] = useState<string | undefined>(() => getAffiliateId());

    const { utm_source, utm_medium, utm_campaign, utm_term } = leadClassification(campaignDetails?.lu, campaignDetails?.du, campaignDetails?.ru);

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "";
        };
    }, []);

    const finalFormUrl = process.env.NEXT_PUBLIC_GLOBAL_FORM_URL || formUrl || DEFAULT_FORM_URL;

    const formUrlWithParams = useMemo(
        () => buildZohoFormUrl(finalFormUrl, { utm_source, utm_medium, utm_campaign, utm_term }, affiliateId, { ebook_name: "migration" }),
        [finalFormUrl, utm_source, utm_medium, utm_campaign, utm_term, affiliateId]
    );

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black bg-opacity-60" onClick={onClose} />
            <div className="relative z-10 bg-white rounded-xl shadow-xl w-full max-w-3xl mx-4">
                <button
                    onClick={onClose}
                    className="absolute text-base leading-none top-1 right-1 z-20 bg-gray-600 text-white w-7 h-7 rounded-full flex items-center justify-center hover:bg-gray-700"
                >
                    ✕
                </button>
                <iframe ref={iframeRef} src={formUrlWithParams} width="100%" height="600px" title="Global Form" style={{ borderRadius: "10px", border: "none" }} />
            </div>
        </div>
    );
};

export default GlobalFormModal;
